import { useQuery } from '@apollo/client';

import { get as getUser } from 'js/lib/user';

import OnDemandSpecializationProgress from 'bundles/s12n-common/api/OnDemandSpecializationProgress.graphql';
import type {
  ProgressQuery,
  ProgressQueryVariables,
} from 'bundles/s12n-common/api/__generated__/OnDemandSpecializationProgress';

const useLastActiveS12nProgress = (s12NId: string) => {
  const userId = getUser().id;
  const { data } = useQuery<ProgressQuery, ProgressQueryVariables>(OnDemandSpecializationProgress, {
    variables: {
      userId,
      s12NId,
    },
    skip: !userId || !s12NId,
    context: { clientName: 'gatewayGql' },
  });

  return data?.OnDemandSpecializationProgress?.progress.lastActiveCourseId ?? undefined;
};

export { useLastActiveS12nProgress };
